<button
  [ngClass]="{ active: isActive, bgActive: isActive }"
  (click)="onClickButton()"
  [style.--status-color]="transmissionStatus?.transmissionStatusColor"
  [style.opacity]="isActive ? 1 : 0.6"
>
  <h6 [style.color]="transmissionStatus?.transmissionStatusColor">
    {{ quantityVehicle }}
  </h6>
  <div class="icon_container">
    <app-icon-transmission-state
      [variant]="transmissionStatus?.transmissionStatusTag"
      [color]="transmissionStatus?.transmissionStatusColor"
      [size]="16"
    ></app-icon-transmission-state>
  </div>
</button>
